document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.site-header-menu-icon').forEach(function (element) {
    element.addEventListener('click', function () {
      // Select all elements with the class 'navmenu-id-products' and 'cstm-mega-submenu'
      const targetElement = document.querySelector('.mobile-nav-content .navmenu-id-products');
      const targetBTN = targetElement.querySelector('a.navmenu-link');
      const targetContainer = targetElement.querySelector('ul.cstm-mega-submenu');
      
      targetElement.classList.add('customopen');
      targetContainer.classList.add('visible');
      targetBTN.classList.add('navmenu-link-parent-active');
      targetBTN.setAttribute('aria-expanded', 'true');
    });
  });
})
